<div *ngIf="errors.length" class="alert alert-danger alert-dismissible" role="alert">
  <button (click)="errors = []" type="button" class="close" data-dismiss="alert" aria-label="Close">
    <span aria-hidden="true">&times;</span>
  </button>
  <span *ngFor="let error of errors">
    <strong>{{ error.field }}</strong> {{ error.message }} <br>
  </span>
</div>
